// Actions
const GET = 'overview/GET';

// Reducer
export default function reducer(state = [], action) {
  switch (action.type) {
    case GET:
      return [...action.payload];
    default:
      return state;
  }
}

// Action Creators
export function getOverviews() {
  const url = `${config.apiHost}/overview`;
  return dispatch => {
    fetch(url)
      .then(response => response.json())
      .then(data => {
        dispatch({
          type: GET,
          payload: data
        });
      });
  };
}



// WEBPACK FOOTER //
// ./app/redux-modules/overview.js